import React from 'react';
import { useTranslation } from 'react-i18next';
import Gas from '@hvcgroep/design-system/assets/illustrations/Gas.svg';
import Heat from '@hvcgroep/design-system/assets/illustrations/Warmte.svg';
import './style.scss';

interface Props {
  standardAnnualUsageInM3: number | string;
  standardAnnualUsageInGJ: number | string;
}

const GJToM3Comparison: React.FC<Props> = (props) => {
  const {
    standardAnnualUsageInM3,
    standardAnnualUsageInGJ,
  } = props;

  const { t } = useTranslation();

  return (
    <p className="GJToM3Comparison faq-item__inner-component">
      <img className="GJToM3Comparison__icon GJToM3Comparison__icon--gas" src={Gas} alt="" />
      <span className="GJToM3Comparison__value GJToM3Comparison__value--gas h4">
        {t('registration_desk.gj_to_m3_comparison.gas', {
          usageInM3: standardAnnualUsageInM3,
        })}
      </span>
      <span className="GJToM3Comparison__comparison-text h4">
        {' '}{t('registration_desk.gj_to_m3_comparison.comparison')}{' '}
      </span>
      <span className="GJToM3Comparison__value GJToM3Comparison__value--heat h4">
        {t('registration_desk.gj_to_m3_comparison.heat', {
          usageInGJ: standardAnnualUsageInGJ,
        })}
      </span>
      <img className="GJToM3Comparison__icon GJToM3Comparison__icon--heat" src={Heat} alt="" />
    </p>
  );
};

export default GJToM3Comparison;
